/* lm-d522.js – CRO-60 (2026-10-16): moved unchanged from snippets/localization-selector.liquid (was an inline <script> on every page). */
(function () {
  if (window.__lmD522) return;
  var lmD522Tag = document.currentScript;
  window.__lmD522 = true;
  var iso = (lmD522Tag && lmD522Tag.dataset.iso) || '';
  var KEY = 'lm_d522_geo_fixed';
  var fix = true;
  try {
    if (/[?&]country=/i.test(window.location.search)) { window.sessionStorage.setItem(KEY, '1'); fix = false; }
    else if (window.localStorage.getItem('lm_country_confirmed') || window.sessionStorage.getItem(KEY)) fix = false;
    else window.sessionStorage.setItem(KEY, '1');
  } catch (e) { fix = false; }
  if (fix) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    /* same call and shared cache as the D13 bar and the D2 delivery line */
    if (!window.__lmGeoSuggest) {
      window.__lmGeoSuggest = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(iso), { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('http'); return res.json(); })
        .then(function (data) {
          var s = data && data.suggestions && data.suggestions[0];
          var c = s && s.parts && s.parts.country;
          return c && c.handle ? { code: c.handle, name: c.name } : null;
        });
    }
    window.__lmGeoSuggest.then(function (s) {
      if (!s || !s.code || s.code === iso) return;
      /* the cookie can sit on both / and the language path (/lt), so both are rewritten */
      function put(base) {
        var fd = new FormData();
        fd.append('form_type', 'localization');
        fd.append('_method', 'put');
        fd.append('country_code', s.code);
        fd.append('return_to', window.location.pathname + window.location.search);
        return fetch(base + 'localization', { method: 'POST', body: fd, credentials: 'same-origin' });
      }
      return put('/').then(function (res) {
        return root !== '/' ? put(root) : res;
      }).then(function (res) {
        if (res.ok) window.location.reload();
      });
    }).catch(function () {});
  }

  var label = (lmD522Tag && lmD522Tag.dataset.label) || '';
  var country = (lmD522Tag && lmD522Tag.dataset.country) || '';
  function open(e) {
    var toggle = document.querySelector('.header__icon-list [aria-controls^="popover-localization-form-country-end"]');
    if (!toggle) return;
    e.preventDefault();
    var wide = window.innerWidth >= 700;
    if (wide && window.scrollY > 0) window.scrollTo(0, 0);
    window.setTimeout(function () { toggle.click(); }, wide ? 150 : 0);
  }
  /* old D2 line (hidden in the v6 PDP) */
  function d2() {
    var a = document.querySelector('.d2-ship a[href*="/policies/shipping-policy"]');
    if (!a || a.hasAttribute('data-d522')) return;
    a.setAttribute('data-d522', '');
    a.textContent = label;
    a.setAttribute('role', 'button');
    a.addEventListener('click', open);
  }
  /* visible v6 delivery line: lm-pdp.js rebuilds .lm-tline, so the link is re-added after each rebuild */
  function tline() {
    var box = document.querySelector('.product-info > .lm-tline');
    if (!box || !box.children.length || box.querySelector('.lm-d522-cc')) return;
    var spans = [].slice.call(box.children);
    var target = spans.filter(function (el) { return country && el.textContent.indexOf(country) > -1; })[0] || spans[0];
    var a = document.createElement('a');
    a.href = '#';
    a.className = 'lm-d522-cc';
    a.setAttribute('role', 'button');
    a.textContent = label;
    a.addEventListener('click', open);
    target.append(' · ', a);
  }
  var queued = false;
  function run() { queued = false; d2(); tline(); }
  function start() {
    run();
    var info = document.querySelector('.product-info');
    if (!info || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!queued) { queued = true; window.requestAnimationFrame(run); }
    }).observe(info, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
